<script>
  import { ignore, getNextId, makeWebsiteRequest } from "../Common/tools";
  import Filter from "../Filter/Filter.svelte";
  import NewList from "../Popups/NewList.svelte";
  import NewSubscriber from "../Popups/NewSubscriber.svelte";
  import Subscribers from "./Tabs/Subscribers.svelte";
  import Lists from "./Tabs/Lists.svelte";
  import Segments from "./Tabs/Segments.svelte";
  import Unsubscribed from "./Tabs/Unsubscribed.svelte";
  import { onMount } from "svelte";
  import { AppState } from "../stores.js";
  import {External, M} from "../external";

  export let data;

  let instance,
    filterInstance,
    tab = "all",
    filters = [],
    currentFilter = "",
    query = "",
    currentSegment = null,
    filteringBy = null;

  const labels = {
    button: {
      all: M.ADD_SUBSCRIBER,
      lists: M.ADD_LIST,
      segments: M.ADD_SEGMENT
    },
    title: {
      all: M.ALL_SUBSCRIBERS,
      lists: M.ALL_LISTS,
      segments: M.ALL_SEGMENTS,
      unsubscribed: M.UNSUBSCRIBED
    },
    popup: {
      all: M.NEW_SUBSCRIBER,
      lists: M.NEW_LIST,
      segments: M.NEW_SEGMENT
    },
    count: {
      all: M.SUBSCRIBERS,
      lists: M.LISTS,
      segments: M.SEGMENTS,
      unsubscribed: M.UNSUBSCRIBED
    }
  };

  let switchTab = (newTab) => {
    filters = [[]];
    filteringBy = null;
    currentSegment = null;
    filterInstance.onFilterChanged();

    query = "";
    tab = newTab;
  };

  let onClickRow = (row) => {
    if (tab === "lists") {
      filters = Object.assign([], filters, [
        [
          {
            func: "is",
            type: External.CRM_FILTER_TYPE.SUBSCRIBER_LIST,
            id: row.id,
            value: row.name
          }
        ]
      ]);
      currentFilter = row.name;
      currentSegment = null;
      filteringBy = "list";
    } else if (tab === "segments") {
      filters = Object.assign([], row.segment, []);
      currentFilter = row.name;
      currentSegment = row;
      filteringBy = "segment";
    }

    tab = "all";
    filterInstance.onFilterChanged();
  };

  let onMainButtonClick = () => {
    let type;
    const buttons = [
      External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, function (popup, context) {
        let formData = popup.component().get();

        switch (tab) {
          case "all":
            if (type === "import") {
              if (formData.list === "" || External.isUndefined(formData.list)) {
                External.Tools.showError(M.SELECT_LIST_IMPORT);
              } else {
                popup.close();
                External.CSVContactsImporter().start(formData.list);
              }
            } else {
              External.Tools.makeWebsiteRequest({
                action: "addContactToMarketingList",
                data: formData,
                onOk: function () {
                  popup.close();
                  instance.onReloadData();
                }
              });
            }
            break;
          case "lists":
            External.Tools.makeWebsiteRequest({
              action: "setMarketingLists",
              data: {
                isNew: true,
                data: JSON.stringify(formData)
              },
              onOk: function () {
                popup.close();
                instance.onReloadData();
              }
            });
            break;
          case "segments":
            let segment = {
              id: getNextId(),
              name: formData.name,
              segment: []
            };

            saveSegment(segment, () => {
              popup.close();
              instance.addItem(segment);
            });
            break;
        }
      }),
      External.Button.MIDDLE_CLOSE
    ];

    External.Tools.showWindow({
      isModal: false,
      title: labels["popup"][tab],
      width: 500,
      buttons: buttons,
      action: {
        onShow: function (popup, ui) {
          switch (tab) {
            case "all":
              popup.bindComponent(
                new NewSubscriber({
                  target: popup.getContentArea(),
                  props: {
                    data: {},
                    onChangeType: function (newType) {
                      type = newType;
                      let button = ui.find(".blue.middle-button");
                      button.text(type === "import" ? M.IMPORT : M.SAVE);
                    }
                  }
                })
              );
              break;
            case "lists":
              popup.bindComponent(
                new NewList({
                  target: popup.getContentArea(),
                  props: { data: {} }
                })
              );
              break;
            case "segments":
              popup.bindComponent(
                new NewList({
                  target: popup.getContentArea(),
                  props: {
                    data: {},
                    title: M.SEGMENT_NAME,
                    description: M.DESCRIBE_SEGMENT
                  }
                })
              );
              break;
          }
        }
      }
    });
  };

  let onFilterChange = () => {
    instance.onReloadData();
    //if (filterInstance.isEmpty()) currentFilter = "";
  };

  let onQuery = () => {
    search();
  };

  let search = External.$.debounce(250, () => {
    instance.onReloadData();
  });

  let onSaveSegment = () => {
    let segments;
    External.Tools.makeWebsiteRequest({
      action: "getMarketingSegments",
      onOk: function (response) {
        segments = response.data;
      }
    });

    External.Tools.promptForInput(M.SEGMENT_NAME, M.ENTER_SEGMENT_NAME, "", (segmentName) => {
      if (segmentName === "") {
        return;
      }

      let segment = {
        id: getNextId(segments),
        segment: filters,
        name: segmentName
      };
      saveSegment(segment, () => {
        currentFilter = segmentName;
        External.Tools.showSaveSuccessWindow();
      });
    });
  };

  let onUpdateSegment = () => {
    let segment = {
      id: currentSegment.id,
      segment: filters,
      name: currentSegment.name
    };

    saveSegment(segment, () => {
      External.Tools.showSaveSuccessWindow();
    });
  };

  const saveSegment = async (segment, then) => {
    let response = await makeWebsiteRequest({
      action: "setMarketingSegment",
      data: {
        data: JSON.stringify(segment)
      }
    });
    (then || ignore)();
  };

  $: currentFilter = tab === "all" && currentFilter !== "" ? currentFilter : labels["title"][tab];

  onMount(() => {
    filterInstance.onFilterChanged();
  });
</script>

<div class="top-background-wrapper wide-top-background" style="padding-top:20px;">
  <div class="top-background filter-wrapper-outer" style="max-width:1200px;">
    <Filter
      enableOR={true}
      bind:this={filterInstance}
      bind:filters
      onChange={onFilterChange}
      hide={tab !== "all"}
      id={currentSegment}
      onSaveSegment={onSaveSegment}
      onUpdateSegment={onUpdateSegment} />
  </div>
  <div class="top-background" style="max-width:1200px;">
    <div class="text-wrapper f-left col20 flex align-center space-between mobile-row flex-col-tablet flex-start-mobile">
      <div class="flex-centered f-left">
        <h2 class="crm-title crm-title-bigger f-left" data-role="activeFilterName">
          {currentFilter} <i class="fa fa-circle" />
        </h2>
        <h2 class="crm-title f-left" data-role="count">
          {data.count}
          {labels["count"][tab]}
        </h2>
        <a rel="action" data-action="tagItems" class="crm-option" style="margin-left: 15px;" on:click={(e) => instance.changeTags(true)} class:none={tab !== "all"}>
          <i class="fa fa-tag" />
          {M.TAG}
        </a>
        <a
          rel="action"
          data-action="showMoreOptions"
          class="crm-option"
          class:none={tab !== "all"}
          style="margin-left: 10px; padding-right: 33px;"
          on:click={(e) => instance.showMoreOptions(e)}>
          {M.MORE}
          <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
            <path d="M4 6l4 4 4-4H4z" />
          </svg>
        </a>
      </div>
      <div style="flex:none;">
        <div class="f-right flex-centered">
          <a
            rel="action"
            data-action="showMoreOptions"
            class="crm-option"
            class:none={tab !== "all"}
            style="margin-left: 10px; padding-right: 33px;"
            on:click={(e) => instance.showColumnOptions(e)}>
            {M.COLUMNS}
            <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
              <path d="M4 6l4 4 4-4H4z" />
            </svg>
          </a>
        </div>
        <a class="f-right middle-button blue with-icon" style="height:42px; line-height:42px;" class:none={!labels["button"][tab]} on:click={onMainButtonClick}>
          {labels["button"][tab]}
        </a>
        <div class="f-right mr-5 search-outer-wrapper" class:none={tab === "all"}>
          <input type="text" name="q" bind:value={query} on:keyup={onQuery} class="search-input border-type-all" placeholder={M.SEARCH_LIST_SEGMENTS} />
          <span class="material-icons"> search </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
  <div class="sections-wrapper members-wrapper horizontal-flex-table">
    <div class="section-bg members-wrapper products-wrapper crm-table-outer">
      <ul class="upper-navigation upper-navigation-full mb-15 mt-15">
        <li>
          <a on:click|preventDefault={() => switchTab("all")} class:active={tab === "all"}>{M.ALL_SUBSCRIBERS}</a>
        </li>
        <li>
          <a on:click|preventDefault={() => switchTab("lists")} class:active={tab === "lists"}>{M.LISTS}</a>
        </li>
        <li>
          <a on:click|preventDefault={() => switchTab("segments")} class:active={tab === "segments"}>{M.SEGMENTS}</a>
        </li>
        <li>
          <a on:click|preventDefault={() => switchTab("unsubscribed")} class:active={tab === "unsubscribed"}> {M.UNSUBSCRIBED}</a>
        </li>
      </ul>
      {#if $AppState.activeImports && $AppState.activeImports.indexOf("IMPORT_CONTACTS") > -1}
        <div class="col20 f-left import-message">{M.IMPORT_IN_PROGRESS}</div>
      {/if}

      {#if tab === "all"}
        <Subscribers bind:data filters={filters} bind:this={instance} onClick={onClickRow} bind:query filteringBy={filteringBy} onEmptyAction={onMainButtonClick} />
      {:else if tab === "lists"}
        <Lists bind:data filters={filters} bind:this={instance} onClick={onClickRow} bind:query filteringBy={filteringBy} />
      {:else if tab === "segments"}
        <Segments bind:data filters={filters} bind:this={instance} onClick={onClickRow} bind:query filteringBy={filteringBy} onEmptyAction={onMainButtonClick} />
      {:else if tab === "unsubscribed"}
        <Unsubscribed bind:data filters={filters} bind:this={instance} onClick={onClickRow} bind:query filteringBy={filteringBy} />
      {/if}
    </div>
  </div>
</div>
